module.exports = __webpack_public_path__ + "img/16-detail.f58aaa3a.webp";